import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-10" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_3 = { class: "tw-text-[16px] tw-text-[#211F58] tw-font-[600] tw-leading-[130%]" }
const _hoisted_4 = { class: "tw-mt-[20px]" }
const _hoisted_5 = { class: "tw-text-[13px] tw-text-[#878787] tw-font-[400] tw-leading-normal" }
const _hoisted_6 = { class: "input-container email-container tw-flex tw-w-full" }
const _hoisted_7 = { class: "input-username-container tw-flex-1" }
const _hoisted_8 = {
  key: 0,
  class: "tw-text-[#F7553C] tw-text-[11px] tw-leading-[130%] tw-mt-[10px] tw-mb-0"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-container tw-mx-[16px] tw-text-[13px] tw-leading-[56px]" }, "@", -1)
const _hoisted_10 = { class: "input-domain-container tw-flex-1" }

import store from "@/store";
import utilities, {
  IsSpecialCharEmailValid,
  getComponentUiText,
} from "@/utils/utilities";
import { computed, reactive, ref, watch, PropType, Ref } from "vue";

import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { postOrgDomainVerifyById } from "@/services/org";
import BaseInput from "@/components/common/form/baseInput.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import BaseForm from "@/components/common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { UserRoute } from "@/services/apiRoutes/routes";
import { IDomain } from "@/interfaces/org/domain";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
const DEFAULT_MAX_WIDTH_MODAL = 65;


export default /*#__PURE__*/_defineComponent({
  __name: 'verifyEmailModal',
  props: {
  show: {
    type: Boolean,
    default: false,
    required: false,
  },
  domain: {
    type: Object as PropType<IDomain>,
    default: () => ({}),
    required: true,
  },
},
  emits: ["update:show", "update:send-email"],
  setup(__props, { emit }) {

const props = __props;




// Custom validation email contain "@".
const validateForEmail = (text: string) => {
  if (text.indexOf("@") === -1) return true;
  else return false;
};

const isLoadingAPI = ref(false);
const innerTextSendMailBtnRef: Ref = ref(null);
const animationWidth = ref(0);
const initialForm = {
  username: "",
  domain: props.domain.domain,
};

// Form modal and validation.
const formModel = reactive({ ...initialForm });

const rules = {
  username: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    isEmail: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-send-verification-email-invalid-username-error-1",
        ),
      validateForEmail,
    ),
    IsSpecialCharEmailValid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-modals-email-invalid-error-1",
        ),
      IsSpecialCharEmailValid,
    ),
  },
};

const $v = useVuelidate(rules, formModel);
let showRef = ref(props.show);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) initial();
    else clearWatchAndListener();
  },
);

watch(
  () => props.domain,
  (value) => {
    formModel.domain = value.domain;
    formModel.username = "";
    $v.value.$reset();
  },
  { immediate: true, deep: true },
);

const initial = () => {
  listeningEvent();
};

const listeningEvent = () => {
  EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ENTER, () => onSendEmail());
};

const clearWatchAndListener = () => {
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
};

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const successMessage = getUiText(
  "app-settings-domain-send-verification-email-success-1",
);

const onSendEmail = async () => {
  await $v.value.$validate();
  if ($v.value.$invalid) return;
  isLoadingAPI.value = true;
  if (innerTextSendMailBtnRef.value) {
    animationWidth.value =
      innerTextSendMailBtnRef.value.getBoundingClientRect()["width"] as number;
  }
  try {
    const email = `${formModel.username}@${formModel.domain}`;
    const formResponse = await postOrgDomainVerifyById(
      Number(props.domain.domainId),
      email,
    );
    if (formResponse.data?.data) {
      onShowToast(successMessage, ToastVariant.SUCCESS);
      emit("update:send-email");
      isLoadingAPI.value = false;
      handleCloseModal();
    }
  } catch (error: any) {
    isLoadingAPI.value = false;
    showErrorAPI(error, UserRoute.postEmailUserVerify);
  }
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const clearData = () => {
  for (const key in formModel) {
    if (Array.isArray(formModel[key])) {
      formModel[key].splice(0); // Clear the array content while maintaining reference
    } else {
      formModel[key] = initialForm[key];
    }
  }
  $v.value.$reset();
};

const handleInputEmail = (val: string) => {
  const email = `${formModel.username}@${formModel.domain}`;
  if (email.trim() === "") $v.value.email.$reset();
  else {
    $v.value.username.$touch();
    $v.value.username.$model = val;
  }
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] verification-email-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    value: formModel,
    visible: _unref(showRef),
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: "modal-header",
        title: `${getUiText('app-settings-domain-verify-email-modal-title-1')} ${
        __props.domain.domain
      }`,
        "hide-close": true
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(getUiText("app-settings-domain-verify-email-modal-sub-title-1")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-domain-verify-email-modal-description-1",
              false,
              { domain: __props.domain.domain },
            )), 1)
        ]),
        _createVNode(BaseForm, {
          "enter-event": true,
          show: _unref(showRef),
          onOnSubmit: onSendEmail
        }, {
          default: _withCtx(() => [
            _createVNode(BaseInput, {
              id: "email",
              modelValue: formModel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel) = $event)),
              "is-required": true,
              label: _unref(getComponentUiText)('app-user-profile-form-label-email-1'),
              placeholder: 
            getUiText(
              'app-settings-team-members-organisation-modal-form-placeholder-title',
            )
          ,
              "col-input-class": 'tw-flex md:tw-w-[80%] lg:tw-w-[520px] !tw-px-0',
              "label-class": 'tw-flex tw-items-center tw-h-[58px] tw-w-[100px] tw-px-0',
              "class-name": `tw-flex tw-items-center tw-justify-between tw-mx-0 tw-gap-[15px]`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_BFormInput, {
                      modelValue: formModel.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.username) = $event)),
                      type: "text",
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-settings-domain-verify-email-modal-username-placeholder-1',
                  )
                ,
                      class: _normalizeClass([
                  'form-control input-base-form-input',
                  _unref($v).username.$error ? 'is-invalid' : '',
                ]),
                      state: _unref($v).username.dirty ? _unref($v).username.$error : null,
                      onInput: handleInputEmail
                    }, null, 8, ["modelValue", "placeholder", "class", "state"]),
                    (
                  _unref($v).username.$errors.length > 0 &&
                  _unref($v).username.$errors.findIndex(
                    (error) => error.$validator !== 'username',
                  ) >= 0
                )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(_unref($v).username.$errors?.[0]?.$message), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_BFormInput, {
                      modelValue: formModel.domain,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.domain) = $event)),
                      type: "text",
                      disabled: true,
                      class: "form-control input-base-form-input"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "label", "placeholder"]),
            _createElementVNode("div", {
              class: _normalizeClass(`button-container tw-flex tw-justify-end ${
            _unref($v).username.$errors.length > 0 ? 'tw-mt-[40px]' : 'tw-mt-[64px]'
          } tw-gap-[14px]`)
            }, [
              _createVNode(_component_b_button, {
                variant: "primary",
                class: "button-cancel tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                onClick: handleCloseModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getUiText("app-settings-domain-delete-modal-action-cancel-1")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                variant: "primary",
                class: "button-send-email tw-flex tw-items-center tw-h-[43px] tw-bg-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                onClick: onSendEmail
              }, {
                default: _withCtx(() => [
                  (!isLoadingAPI.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        ref_key: "innerTextSendMailBtnRef",
                        ref: innerTextSendMailBtnRef,
                        class: "tw-text-[13px] tw-font-medium tw-leading-[100%]"
                      }, _toDisplayString(getUiText("app-settings-send-verification-email-1")), 513))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle({ width: animationWidth.value + 'px' }),
                        class: "tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
                      }, [
                        _createVNode(_unref(LottieAnimation), {
                          ref: "anim",
                          "animation-data": _unref(ProgressAnimation),
                          "auto-play": true,
                          loop: true
                        }, null, 8, ["animation-data"])
                      ], 4))
                ]),
                _: 1
              })
            ], 2)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["value", "visible"]))
}
}

})